/**
 * The garden's plants and what can be done to them, from PlantsContext.
 *
 * A hook rather than useContext at each call, so a component outside its
 * provider fails at once with a sentence saying so, instead of reading
 * undefined and failing somewhere further on.
 *
 * PlantsProvider is mounted per route (App), only around the pages that
 * read the plants.
 *
 * @module usePlantsContext
 */

import { useContext } from 'react';
import { PlantsContext, PlantsContextType } from '../context/PlantsContextDefinition';

/**
 * The PlantsProvider's value.
 *
 * @returns The garden's plants and the actions on them.
 * @throws Error when called outside a PlantsProvider.
 */
export function usePlantsContext(): PlantsContextType {
  const context = useContext(PlantsContext);
  if (context === undefined) {
    throw new Error('usePlantsContext must be used within a PlantsProvider');
  }
  return context;
}